import React, { createContext, useEffect, useState, useCallback } from "react";
import { v4 as uuidv4 } from "uuid";
import { auth, db, tsToMillis, serverTime } from "../Utils/firebase";

export const AuthContext = createContext();

const AuthContextProvider = (props) => {
  const [userAuth, setUserAuth] = useState(null);
  const [userData, setUser] = useState(null);
  const [visitor, setVisitor] = useState(null);
  const [click, setClick] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const setLoadingTrue = () => {
    setIsLoading(true);
  };

  const setLoadingFalse = () => {
    setIsLoading(false);
  };

  const setUserData = (data) => {
    setUser(data);
  };

  const logout = () => {
    setUserAuth(null);
  };

  const createNewData = useCallback((user) => {
    const getRanUn = uuidv4();
    const ranUs = getRanUn.replace(/-/g, "");

    const newData = {
      account: [],
      color: 0,
      createAt: serverTime,
      link: [],
      message: "Get in Touch!",
      name: user.displayName,
      photo_url: "",
      theme: "light",
      title: "My Title",
      updateAt: serverTime,
      username: ranUs,
      valid_until: serverTime,
    };

    db.collection("user")
      .doc(user.uid)
      .set(newData)
      .then(() => {
        db.collection("user")
          .doc(user.uid)
          .get()
          .then((doc) => {
            setUserAuth(user);
            setUserData(doc.data());
            setLoadingFalse();
          })
          .catch((error) => {
            console.log(error);
            setLoadingFalse();
          });
        // setUserAuth(user);
      })
      .catch((error) => {
        console.log(error);
        setLoadingFalse();
      });
  }, []);

  const getClicks = useCallback((id) => {
    db.collection("analytic")
      .doc(id)
      .collection("clicks")
      .get()
      .then((snapShot) => {
        if (snapShot.empty) {
          setLoadingFalse();
        } else {
          let data = [];
          snapShot.forEach((doc) => {
            data.push(doc.data());
          });
          setClick(data);
          setLoadingFalse();
        }
      })
      .catch((err) => {
        setLoadingFalse();
        console.log(err);
      });
  }, []);

  const getVisitor = useCallback(
    (id) => {
      const compareDate = new Date(tsToMillis - 30 * (24 * 60 * 60 * 1000));

      db.collection("analytic")
        .doc(id)
        .collection("visitors")
        .where("visit_at", ">", compareDate)
        .get()
        .then((snapShot) => {
          if (snapShot.empty) {
            getClicks(id);
          } else {
            let data = [];
            snapShot.forEach((doc) => {
              data.push(doc.data());
            });

            setVisitor(data);
            getClicks(id);
          }
        })
        .catch((err) => {
          setLoadingFalse();
          console.log(err);
        });
    },
    [getClicks]
  );

  useEffect(() => {
    auth.onAuthStateChanged(function (user) {
      if (user) {
        // User is signed in.
        // console.log(user);
        setLoadingTrue();
        db.collection("user")
          .doc(user.uid)
          .get()
          .then((doc) => {
            if (doc.exists) {
              db.collection("user")
                .doc(user.uid)
                .get()
                .then((doc) => {
                  const data = doc.data();
                  setUserAuth(user);
                  setUserData(data);
                  getVisitor(user.uid);
                  // setLoadingFalse();
                })
                .catch((error) => {
                  setLoadingFalse();
                  console.log(error);
                });
            } else {
              if (user.emailVerified === true) {
                createNewData(user);
              } else {
                setUserAuth(user);
                setLoadingFalse();
              }
            }
          })
          .catch((error) => {
            setLoadingFalse();
            console.log(error);
          });
      } else {
        // No user is signed in.
        logout();
        setLoadingFalse();
      }
    });

    return;
  }, [createNewData, getVisitor]);

  return (
    <AuthContext.Provider
      value={{
        userAuth,
        logout,
        isLoading,
        setLoadingFalse,
        setLoadingTrue,
        userData,
        setUserData,
        visitor,
        click,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContextProvider;
